var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.54995 0L4.44995 0.34V10.14L4.54995 10.24L9.09995 7.55L4.54995 0Z",
    fill: "#D12663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55 0L0 7.55L4.55 10.24V5.48V0Z",
    fill: "#E06A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54999 11.0999L4.48999 11.1699V14.6599L4.54999 14.8199L9.09999 8.40991L4.54999 11.0999Z",
    fill: "#CE2561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55 14.8199V11.0999L0 8.40991L4.55 14.8199Z",
    fill: "#E06A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55005 10.24L9.10005 7.54998L4.55005 5.47998V10.24Z",
    fill: "#570D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.54998L4.55 10.24V5.47998L0 7.54998Z",
    fill: "#CE2561"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.1,
    height: 14.82,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIco);
export default __webpack_public_path__ + "static/media/eth_ico.9613c62a0a7c2d3ca8b897aa7369af2e.svg";
export { ForwardRef as ReactComponent };